import { call, put, takeLatest } from "redux-saga/effects";
import { checkinBoardingPassDataRequest, getCheckinBoardingPassSuccess, getCheckinBoardingPassFailure, googleWalletBpSuccess, googleWalletBpFailure, googleWalletBpRequest, appleWalletBpRequest, appleWalletBpSuccess, appleWalletBpFailure, savePdfRequest, savePdfSuccess, savePdfFailure, sendEmailRequest, sendEmailSuccess, sendEmailFailure } from "../../slice/checkin/checkinBoardingPassSlice";
import api from "../../../../config/api";
import { config } from "../../../../config/global";
const headerData = {
  mode: "no-cors",
  headers: {
    accesstoken: localStorage.getItem("accesstoken"),
    "Content-Type": "application/json",
    "User-Agent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/134.0.0.0 Safari/537.36"
  },
  loader: true,
  isGenericErr: true,
  isBadRequestExceptional: false
};

// Boarding Pass
const fetchBoardingPassData = async payload => {
  const BOARDING_PASS_API_URL = config.CHECKIN_BOARDING_PASS;
  // let payloadData = {
  //   journeyId: payload,
  // };
  const response = await api.post(BOARDING_PASS_API_URL, payload, headerData);
  return response;
};
function* getCheckinBoardingPassData(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchBoardingPassData, payload);
    yield put(getCheckinBoardingPassSuccess(response?.data));
  } catch (error) {
    yield put(getCheckinBoardingPassFailure(error?.response));
  }
}
export function* watchCheckinBoardingPassData() {
  yield takeLatest(checkinBoardingPassDataRequest.type, getCheckinBoardingPassData);
}

// Google Wallet
const fetchBoardingPassGoogleWallet = async payload => {
  const BOARDING_PASS_GOOGLE_API_URL = config.CHECKIN_BOARDING_PASS_GOOGLE_WALLET;
  if (payload?.flightNumber?.length > 0) {
    payload.flightNumber = payload?.flightNumber;
  }
  const response = await api.post(BOARDING_PASS_GOOGLE_API_URL, payload, headerData);
  return response;
};
function* getCheckinBoardingPassGoogleWallet(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchBoardingPassGoogleWallet, payload);
    yield put(googleWalletBpSuccess(response));
  } catch (error) {
    yield put(googleWalletBpFailure(error?.response));
  }
}
export function* watchCheckinBoardingPassGoogleWallet() {
  yield takeLatest(googleWalletBpRequest.type, getCheckinBoardingPassGoogleWallet);
}

// Apple Wallet
const fetchBoardingPassAppleWallet = async payload => {
  const BOARDING_PASS_APPLE_API_URL = config.CHECKIN_BOARDING_PASS_APPLE_WALLET;
  if (payload?.flightNumber?.length > 0) {
    payload.flightNumber = payload?.flightNumber;
  }
  const response = await api.post(BOARDING_PASS_APPLE_API_URL, payload, headerData);
  return response;
};
function* getCheckinBoardingPassAppleWallet(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchBoardingPassAppleWallet, payload);
    yield put(appleWalletBpSuccess(response));
  } catch (error) {
    yield put(appleWalletBpFailure(error?.response));
  }
}
export function* watchCheckinBoardingPassAppleWallet() {
  yield takeLatest(appleWalletBpRequest.type, getCheckinBoardingPassAppleWallet);
}

// Save, Save All
const fetchBoardingPassSavePdf = async payload => {
  const BOARDING_PASS_SAVE_API_URL = config.CHECKIN_BP_SAVE_PDF;
  const payloadData = {};
  if (payload?.journeyElementId) {
    payloadData.journeyId = payload?.journeyId;
    payloadData.journeyElementId = payload?.journeyElementId;
  } else {
    payloadData.journeyId = payload.journeyId;
  }
  if (payload?.flightNumber?.length > 0) {
    payloadData.flightNumber = payload?.flightNumber;
  }
  const response = await api.post(BOARDING_PASS_SAVE_API_URL, payloadData, headerData);
  return response;
};
function* getCheckinBoardingPassSavePdf(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchBoardingPassSavePdf, payload);
    yield put(savePdfSuccess(response));
  } catch (error) {
    yield put(savePdfFailure(error?.response));
  }
}
export function* watchCheckinBoardingPassSavePdf() {
  yield takeLatest(savePdfRequest.type, getCheckinBoardingPassSavePdf);
}

// Send Email
const fetchBoardingPassSendEmail = async payload => {
  const BOARDING_PASS_SEND_EMAIL_API_URL = config.DAPI_CHECKIN_BP_SEND_EMAIL;
  const payloadData = {};
  if (payload?.sendAll) {
    payloadData.journeyId = payload.journeyId;
    payloadData.emailId = payload?.emailId;
  } else {
    payloadData.journeyId = payload?.journeyId;
    payloadData.journeyElementId = payload?.journeyElementId;
    payloadData.emailId = payload?.emailId;
  }
  if (payload?.flightNumber?.length > 0) {
    payloadData.flightNumber = payload?.flightNumber;
  }
  const response = await api.post(BOARDING_PASS_SEND_EMAIL_API_URL, payloadData, headerData);
  return response;
};
function* getCheckinBoardingPassSendEmail(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchBoardingPassSendEmail, payload);
    yield put(sendEmailSuccess(response));
  } catch (error) {
    yield put(sendEmailFailure(error?.response));
  }
}
export function* watchCheckinBoardingPassSendEmail() {
  yield takeLatest(sendEmailRequest.type, getCheckinBoardingPassSendEmail);
}